const home: Record<string, string> = {
  'brand.name': 'Arche de l’espoir',
  'brand.full': 'Arche de l’espoir des communautés africaines et canadiennes',
  'brand.fullFr': 'African and Canadian Community Ark of Hope',
  'brand.tagline': 'Un havre sûr. Un chemin équitable. Un avenir plus fort.',
  'brand.descriptor': 'Un organisme sans but lucratif bilingue qui fait progresser l’équité, la dignité, les possibilités et l’appartenance pour les femmes, les nouveaux arrivants, les familles et les communautés mal desservies.',
  'brand.long': 'L’Arche de l’espoir des communautés africaines et canadiennes est un organisme sans but lucratif bilingue, ancré dans la communauté, qui travaille à éliminer les barrières systémiques et à renforcer le bien-être social et économique des femmes, des filles, des nouveaux arrivants, des familles, des personnes en situation de handicap et d’autres communautés qui méritent l’équité.',
  'site.email': 'african.canadian.arkofhope@gmail.com',
  'site.skip': 'Aller au contenu principal',

  'nav.home': 'Accueil',
  'nav.about': 'À propos',
  'nav.work': 'Notre travail',
  'nav.ark': 'L’ARK des titres de compétences',
  'nav.impact': 'Impact et changement systémique',
  'nav.partners': 'Partenaires',
  'nav.involved': 'S’impliquer',
  'nav.news': 'Nouvelles et ressources',
  'nav.contact': 'Nous joindre',
  'nav.donate': 'Faire un don',
  'nav.langFr': 'Français',
  'nav.langEn': 'English',
  'nav.langAria': 'Changer la langue entre le français et l’anglais',
  'nav.menu': 'Ouvrir le menu',
  'nav.close': 'Fermer le menu',

  'film.alt': 'Au ras de la mer à l’aube, l’embrun jaillit jusque dans une salle communautaire où des chaises sont disposées en cercle, des personnes se rassemblent autour de tables dans une lumière dorée, puis la salle éclairée borde une eau calme à l’heure bleue.',
  'b1.stamp': 'Un havre sûr. Un chemin équitable. Un avenir plus fort.',
  'b1.h': 'Bâtir des parcours équitables<br>où chaque personne peut <em class="accent">appartenir</em>, contribuer et s’épanouir.',
  'b1.sub': 'Un organisme sans but lucratif bilingue qui fait progresser l’équité, la dignité, les possibilités et l’appartenance pour les femmes, les nouveaux arrivants, les familles et les communautés mal desservies.',
  'b1.cta': 'Découvrir notre travail',
  'b1.cta2': 'S’impliquer',
  'b2.stamp': 'Arche de l’espoir des communautés africaines et canadiennes',
  'b2.h': 'Un havre sûr.<br>Un chemin équitable.<br>Un avenir plus <em class="accent">fort</em>.',
  'b2.sub': 'L’Arche de l’espoir des communautés africaines et canadiennes est un organisme sans but lucratif bilingue, ancré dans la communauté, qui travaille à éliminer les barrières systémiques et à renforcer le bien-être social et économique des femmes, des filles, des nouveaux arrivants, des familles, des personnes en situation de handicap et d’autres communautés qui méritent l’équité.',
  'b2.chip1': 'Français · English',
  'b2.chip2': 'Mené par la communauté',
  'b2.chip3': 'Changement systémique',
  'b2.cta': 'S’impliquer',

  'manifesto.text': 'L’espoir devient [[puissant]] lorsqu’il s’allie aux possibilités, à la dignité et à l’action concrète.',
  'welcome.p1': 'Nous travaillons aux côtés des communautés, et non simplement pour elles, afin de créer des systèmes plus justes, des réseaux plus solides et des parcours durables vers la participation et le leadership.',
  'welcome.p2': 'Par un engagement culturellement adapté, l’éducation, la défense des droits, le mentorat et les partenariats, nous aidons à transformer l’expérience vécue en solutions éclairées par la communauté.',

  'hm.focus.eyebrow': 'Nos priorités',
  'hm.focus.h': 'Nos <em class="accent">priorités</em>.',
  'hm.focus.p': 'Cinq domaines interreliés orientent l’élaboration de nos programmes et de nos partenariats.',
  'hm.focus.link': 'Voir notre travail',
  'hm.focus.cta': 'Découvrir notre travail',
  'focus.1t': 'Égalité et leadership des femmes',
  'focus.1p': 'Faire progresser la sécurité, la sécurité économique, la représentation et le pouvoir décisionnel des femmes et des filles de divers horizons.',
  'focus.2t': 'Inclusion des nouveaux arrivants et des professionnels',
  'focus.2p': 'S’attaquer aux obstacles liés à la reconnaissance des diplômes étrangers, à l’expérience canadienne, aux réseaux professionnels et à l’avancement équitable.',
  'focus.3t': 'Bien-être des jeunes et des familles',
  'focus.3p': 'Renforcer la résilience, les compétences, l’appartenance et l’accès aux mesures de soutien communautaire.',
  'focus.4t': 'Accessibilité et inclusion des personnes en situation de handicap',
  'focus.4p': 'Favoriser une participation accessible et éliminer les obstacles d’ordre attitudinal, communicationnel et institutionnel.',
  'focus.5t': 'Engagement communautaire bilingue',
  'focus.5p': 'Servir les communautés anglophones et francophones et mobiliser de façon significative les communautés francophones en situation minoritaire.',

  'hm.change.eyebrow': 'Comment nous créons le changement',
  'hm.change.h': 'Comment nous créons le <em class="accent">changement</em>.',
  'hm.change.p1': 'Nous écoutons les personnes les plus touchées, réunissons les institutions et les communautés autour d’une même table, concevons des solutions pratiques en collaboration et appuyons les organisations qui modifient les politiques et les pratiques perpétuant les inégalités.',
  'hm.change.p2': 'Notre objectif n’est pas de demander aux gens de s’adapter à des systèmes injustes. Notre objectif est de contribuer à rendre ces systèmes équitables.',
  'hm.change.cta': 'Impact et changement systémique',

  'hm.ark.eyebrow': 'Initiative phare',
  'hm.ark.tag': 'En cours d’élaboration',
  'hm.ark.h': 'L’ARK des<br><em class="accent">titres</em>.',
  'hm.ark.p': 'Éliminer les barrières systémiques auxquelles se heurtent les femmes professionnelles nouvelles arrivantes et racisées. L’initiative est en cours d’élaboration et vise à changer les systèmes plutôt qu’à demander aux femmes de porter seules le fardeau des obstacles discriminatoires.',
  'hm.ark.cta': 'En savoir plus sur l’ARK des titres de compétences',

  'hm.close.eyebrow': 'Joignez-vous à nous',
  'hm.close.h': 'Ensemble, passons<br>des barrières à l’<em class="accent">appartenance</em>.',
  'hm.close.p': 'Que vous soyez membre de la communauté, bénévole, employeur, association professionnelle, établissement d’enseignement, bailleur de fonds ou fournisseur de services, il y a une place pour vous dans ce travail.',
  'hm.close.b1': 'Devenir partenaire',
  'hm.close.b2': 'Faire du bénévolat',
  'hm.close.b3': 'Faire un don',

  'ft.line': 'Faire progresser l’équité, la dignité,<br>les possibilités et l’<em class="accent">appartenance</em>.',
  'ft.desc': 'Faire progresser l’équité, la dignité, les possibilités et l’appartenance.',
  'ft.explore': 'Explorer',
  'ft.more': 'En savoir plus',
  'ft.contact': 'Nous joindre',
  'ft.legal': 'Mentions légales',
  'ft.privacy': 'Confidentialité',
  'ft.access': 'Accessibilité',
  'ft.phone': '[Téléphone : à ajouter]',
  'ft.address': '[Adresse postale : à ajouter]',
  'ft.hours': '[Heures de service : à ajouter]',
  'ft.social': '[Liens sociaux : à ajouter]',
  'ft.rights': 'Copyright © Arche de l’espoir des communautés africaines et canadiennes. Tous droits réservés.',

  'faq.eyebrow': 'Foire aux questions',
  'faq.h': 'Vos questions, <em class="accent">nos réponses</em>.',
  'faq.pending': '[Réponse : à ajouter]',
  'faq.q1': 'Qui l’organisme sert-il ?',
  'faq.q2': 'Les services sont-ils offerts en français et en anglais ?',
  'faq.q3': 'L’ARche des titres est-elle un service de placement professionnel ?',
  'faq.q4': 'Comment une organisation peut-elle devenir partenaire ?',
  'faq.q5': 'Puis-je faire du bénévolat ?',
  'faq.q6': 'Recevrai-je un reçu d’impôt pour un don ?',

  'nf.stamp': '404',
  'nf.h': 'Cette page est introuvable.',
  'nf.p': 'L’adresse a peut-être changé, ou la page n’existe pas encore. Veuillez utiliser le menu ou revenir à la page d’accueil.',
  'nf.home': 'Retour à l’accueil',

  'form.name': 'Nom',
  'form.email': 'Courriel',
  'form.phone': 'Téléphone',
  'form.organization': 'Organisation',
  'form.languages': 'Langues parlées',
  'form.availability': 'Disponibilité',
  'form.accessibility': 'Besoins en matière d’accessibilité',
  'form.message': 'Message',
  'form.preferred': 'Langue de préférence',
  'form.english': 'English',
  'form.french': 'Français',
  'form.consent': 'J’accepte d’être contacté(e) par l’Arche de l’espoir des communautés africaines et canadiennes au sujet de cette demande.',
  'form.required': 'Les champs marqués d’un * sont obligatoires.',
  'form.notice': 'Nous utilisons vos renseignements uniquement pour répondre à votre demande.',
  'form.send': 'Envoyer',
  'form.sending': 'Envoi en cours…',
  'form.ok': 'Merci. Votre message a été reçu et parviendra directement à notre équipe.',
  'form.again': 'Envoyer un autre message',
  'form.err': 'Votre message n’a pas pu être envoyé. Veuillez réessayer dans un instant ou nous écrire directement à african.canadian.arkofhope@gmail.com.',
  'form.vName': 'Veuillez indiquer votre nom.',
  'form.vEmail': 'Veuillez indiquer une adresse courriel valide.',
  'form.vMessage': 'Veuillez écrire un court message (500 caractères maximum).',
  'form.vRequired': 'Veuillez remplir les champs obligatoires.',
  'form.vConsent': 'Veuillez confirmer que nous pouvons vous contacter.',
};

export default home;